export enum BankSelectionActionTypes {
  SELECT_BANK = 'SELECT_BANK',
}
